module.exports = __webpack_public_path__ + "static/media/2.ddef54d0.jpg";